<template>
    <div class="toast-wrapper">
        <div class="snackbar" :class="{ 'success': isSuccess, 'danger': !isSuccess }">
            {{ message }}
        </div>
    </div>
</template>

<script>
export default {
    name: "SnackbarComponent",
    props: {
        message: String,
        isSuccess: Boolean,
    },
}
</script>

<style scoped>
.toast-wrapper {
    position: fixed;
    width: 100%;
    top: 10px;
    z-index: 9999;
}

.snackbar {
    padding: 10px;
    color: white;
    border-radius: 10px;
    box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.2);
    max-width: 400px;
    margin: 0 5px;
    float: right;
    min-width: 250px;
}

.success {
    background: green;
}

.danger {
    background: red;
}
</style>

